var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "team-list" }, [
    _c("h4", { staticClass: "title" }, [
      _vm._v(" " + _vm._s(_vm.$t("planLxDetail.TDXX")) + " "),
    ]),
    _c(
      "div",
      { staticClass: "list-box" },
      [
        _vm.listArr.length
          ? _vm._l(_vm.listArr, function (item) {
              return _c("list-item", {
                key: item.initKeyId,
                attrs: {
                  pageBtnStatusDto: _vm.pageBtnStatusDto,
                  planDto: _vm.planDto,
                  itemData: item,
                },
              })
            })
          : _c("div", { staticClass: "null-list" }, [
              _c("img", {
                attrs: { src: require("@/assets/image/null-list.png") },
              }),
            ]),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }